import React from 'react';
import useLoadingForm from '../../hooks/loadingFormHook';
import LoadingSpinner from '../../static/dashboard/loadingspinner.svg';
import Wave from '../../static/dashboard/wave.svg';
import '../../styles/dashboard/PaymentFailed.css';

export default function PaymentFailed() {
    const payFunction = () => {
        return fetch("https://flash.siwalik.in/delay/500",
        {method: "GET"});
    }
    
    const paidHandler = () => {
        /* Insert any code necessary to run after attempted payment.*/
    }

    const { formData, handleChange, loading, handleSubmit } = useLoadingForm({
        card: '',
    }, payFunction, paidHandler);

    return (
        <div className="PaymentFailed center-dashboard-content full-width no-nav">
            <img src={Wave} alt="Salewave Logo"/>
            <div className="header header-short text-center">
                <h1>Your payment failed :(</h1>
                <p>Try again below to continue to Salewave</p>
                <form 
                onSubmit={handleSubmit}
                className="formDashboard">
                    <input 
                    type="text"
                    name="card"
                    value={formData.card}
                    placeholder="Card Number MM/YY CVV"
                    onChange={handleChange} />
                    <button 
                    className="red"
                    type="submit">
                    {
                        loading 
                        ?
                            <>
                                <img src={LoadingSpinner} alt="Loading..." />
                                Attempting to Pay
                            </>
                        : "Pay & Continue"
                    }
                    </button>
                </form>
            </div>
        </div>
    )
}